import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import interfaceToast from './interfaceToast-zh-CN';

let zhCN = {
  interfaceToast: interfaceToast,
  "common": {
    "corporate": "深圳市健成星云科技有限公司",
    "corporate2": "深圳市健成星云科技有限公司 版权所有",
    "appName": "星云心理健康运营平台",
    "query": "查询",
    "screeningConditions": "开关筛选条件",
    "add": "添加",
    "delete": "删除",
    "refresh": "刷新",
    "operation": "操作",
    "edit": "编辑",
    "noDataHint": "暂无相关数据",
    "cancel": "取消",
    "conserve": "保存",
    "empty": "清空",
    "sure": "确定",
    "tips": "提示",
    "deleteSuc": "删除成功",
    "pleaseChoose": "请选择",
    "status": "状态",
    "importTemplate": "导入模板",
    "downloadTemplate": "下载模板",
    "preview": "预览",
    "yes": "是",
    "no": "否",
    "addSub": "添加成功",
    "updataSub": "更改已保存成功",
    "affiliatedOrganization": "所属组织",
    "affiliatedOrganizationHint": "请选择所属组织",
    "viewDetail": "查看详情",
    "view": "查看",
    "createTime": "创建时间",
    "createPeople": "创建人",
    "to": "至",
    "endDate": "结束日期",
    "startDate": "开始日期",
    "peoples": "{0}人",
    "completed": "已完成",
    "incomplete": "未完成",
    "inProgress": "进行中",
    "notStarted": "未开始",
    "confirmed": "已确认",
    "canceled": "已取消",
    "process": "审核",
    "reviewFailed": "审核不通过",
    "approved": "审核通过",
    "audit": "待审核",
    "level": "{0}级",
    "normal": "正常",
    "mild": "轻度",
    "moderate": "中度",
    "severe": "重度",
    "crisis": "危机",
    "name": "姓名",
    "age": "年龄",
    "studentID": "学号",
    "sex": "性别",
    "man": "男",
    "woman": "女",
    "school": "学校",
    "nianji": "年级/班级",
    "minute": "{0}分钟",
    "score": "分数",
    "wangeditorPlaceholder": "在这里记录你的想法吧",
    "serialNumber": "序号",
    "manualEntry": "手动录入",
    "systemPlatform": "系统平台",
    "noPermission": "该用户无此功能权限",
    "selectNumber": "已选{0}个",
    "upload": "上传",
    "batchImport": "批量导入",
    "batchImportHint": "导入成功",
    "student": "学生",
    "teacher": "老师",
    "parent": "家长",
    "province": "省",
    "city": "市",
    "area": "区",
    "school": "学校",
    "position": "位置",
    "selectPositionHint": "请点击地图选择位置",
    "searchHint": "请输入搜索关键字",
    "expirationDate": "有效期",
    "remark": "备注",
    "remarkHint": "请输入备注",
    "student": "学生",
    "teacher": "老师",
    "parent": "家长",
    "enable": "启用",
    "bulkEnable": "启用当前勾选的用户状态",
    "bulkEnable2": "启用当前查询结果的用户状态",
    "disable": "禁用",
    "bulkDisable": "禁用当前勾选的用户状态",
    "bulkDisable2": "禁用当前查询结果的用户状态",
    "topping": "置顶",
    "cancelTopping": "取消置顶",
    "customFields": "自定义字段",
    "customFieldsName": "自定义字段名称",
    "customFieldsNameHint": "请输入自定义字段名称",
    "customFieldsNameHint2": "自定义字段名称不能重复",
    "pleaseEnter": "请输入",
    "date_com1": '至',
    'date_com2': '开始日期',
    'date_com3': '结束日期',
    withdraw: "撤回",
    "operationSuccessful": '操作成功',
    fileSizeBig50: "文件大小不能超过50MB",
    fileSizeBig1024: "文件大小不能超过1GB",
    "publicOrHidden": "隐藏/公开"
  },
  "dialogHint": {
    "exitSaveHint": "您还尚未保存，确定要离开吗？",
    "select0Hint": "请先选中至少一个才能进行此操作",
    "deleteHintCommon": "删除 \"&&\" 成功将不可恢复，确定吗？",
    "deleteCommon": "删除该数据将不可恢复，确定吗？"
  },
  "notFound": {
    "hint": "很抱歉，没有找到您要访问的页面",
    "returnHome": "返回首页",
    "last": "上一步"
  },
  "tab": {
    "fullScreen": "全屏",
    "exitFullScreen": "退出全屏",
    "myAccount": "我的账号",
    "logOut": "退出登录",
    "changePassword": "修改密码",
    "passwordVerifiers": "密码校验",
    "changePasswordHint": "密码修改成功",
    "oldPassword": "旧密码",
    "oldPasswordHint": "请输入旧密码",
    "newPassword": "新密码",
    "newPasswordHint": "请输入新密码",
    "newPassword2": "确认密码",
    "newPassword2Hint": "请再次输入新密码",
    "newPassword2Hint2": "两次输入的新密码不相同",
  },
  ...zhLocale
}
export default zhCN;



// WEBPACK FOOTER //
// ./src/i18n/zh-CN.js